<template>
<div>

    <div class="header-banner">
    <section class="section header-block">
        <div class="container">
            <h1>
            <nav class="admin breadcrumb" aria-label="breadcrumbs">
              <ul>
                <li><router-link tag="a" :to="{name: 'admin'}">Admin</router-link></li>
                <li class="is-active"><a href="#">Cast members</a></li>
              </ul>
            </nav>
                Cast members
            </h1>
        </div>
      </section>
    </div>


    <div class="section">


        <div class="container">
            <h2 class="title">Cast members</h2>
            <strong>INCOMPLETE FUNCTIONALITY - IGNORE THIS SECTION</strong><br/>
            
        </div>

    </div>

</div>
</template>

<style scoped>
/* .headline{
    margin-top: 1em;
    display: flex;
    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
} */
</style>

<script>
import Api from '@/config/Api'
import { mapState } from 'vuex'

//import ProductGroupCards from '../cards/ProductGroupCards';
//import ProductCards from '../cards/ProductCards';

export default {
    name: 'adminCastmembers',
    data() {
        return {
            menuitems: [
                {
                    _id: 0,
                    name: "Plays",
                    routelink: "admin-plays"
                },
                {
                    _id: 1,
                    name: "Blogs",
                    routelink: "admin-blogs"
                },
                {
                    _id: 3,
                    name: "Cast members",
                    routelink: "admin-castmembers"
                },
            ],
            /* categories: [] */
        }
    },
    components: {
        //ProductGroupCards,
        //ProductCards
    },
    computed: {
        ...mapState({profile: state => state.user.profile}),
        country() {
            return this.$store.getters.getCountry
        }
    },
    created() {
        /* Api().get('/api/user/productGroupsAndProducts')
        .then(response => {
            this.myProductGroups = response.data.productGroups;
            this.myProducts = response.data.products;
        }); */
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/accounts/AdminCastmembers.vue